import { VuexModule, Module, Mutation, Action } from "vuex-class-modules";

export type CreditModalState = 'about' | 'credits';
@Module
export class ModalModule extends VuexModule {
  private _closes: number = 0;
  private _opens: number = 0;
  private _id: number = -1;
  private _onClosed: number = 0;
  private _creditOpens: number = 0;
  private _creditModalState: CreditModalState = 'about';

  get closes() : number {
    return this._closes;
  }

  get creditOpens(): number {
    return this._creditOpens;
  }

  get onClosed(): number {
    return this._onClosed;
  }

  get opens(): number {
    return this._opens;
  }

  get id(): number {
    return this._id;
  }

  get creditModalState() {
    return this._creditModalState;
  }

  @Mutation
  private triggerCreditOpens() : void {
    this._creditOpens++;
  }

  @Mutation
  private triggerClose() : void {
    this._closes++;
  }

  @Mutation
  private triggerOnClosed() : void {
    this._onClosed++;
  }

  @Mutation
  private triggerOpens(id: number) : void {
    this._id = id;
    this._opens++;
  }

  @Mutation
  private triggerCreditModalState(state: CreditModalState) {
    this._creditModalState = state;
  }

  @Action
  openCredits(): void {
    this.triggerCreditOpens();
  }

  @Action
  close(): void {
    this.triggerClose();
  }

  @Action
  setCreditModalState(state: CreditModalState) {
    this.triggerCreditModalState(state);
  }

  @Action
  onClose(): void {
    this.triggerOnClosed();
  }

  @Action
  open(id: number): void {
    this.triggerOpens(id);
  }
}